import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";

const Wrapper = styled.div``;

const Button = styled.button<{ size?: string }>`
  font-size: ${(props) => props.size || "1.5rem"};
  color: var(--secondary-font-color);
  cursor: pointer;
  transition: transform 0.2s ease-in-out;
  padding: 0 4px;
  border: none;
  background-color: transparent;
  font-family: Georgia, serif;
  font-weight: bold;

  &:hover {
    transform: scale(1.2);
  }
`;

const DropdownWrapper = styled.div<{ $isOpen: boolean; $autoWidth?: boolean }>`
  position: absolute;
  margin-top: ${(props) => (props.$autoWidth ? "" : "1.5rem")};
  background-color: white;
  padding: 10px;
  z-index: 1000;
  border-top: 1px solid rgba(0, 0, 0, 0.15);
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.2);
  display: ${(props) => (props.$isOpen ? "block" : "none")};
  transform: translateX(-50%);
  left: ${(props) => (props.$autoWidth ? "" : "50%")};
  width: ${(props) => (props.$autoWidth ? "auto" : "97%")};
`;

interface Props {
  name?: string;
  icon?: React.ReactNode;
  content: React.ReactElement<{ closeDropdown?: () => void }>;
  onClick?: (...args: any[]) => void;
  size?: string;
  autoWidth?: boolean;
  hoverActive?: boolean;
}

const Dropdown: React.FC<Props> = ({
  name,
  icon,
  content,
  onClick,
  size,
  autoWidth,
  hoverActive,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const toggleDropdown = (e: React.MouseEvent) => {
    e.stopPropagation(); // 🛑 Blochează propagarea din start

    if (onClick) {
      onClick(e, isOpen); // Trimite evenimentul pentru control
    } else {
      setIsOpen((prev) => !prev);
    }
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <Wrapper
      ref={dropdownRef}
      onMouseEnter={() => hoverActive && setIsOpen(true)}
    >
      <Button size={size} onClick={toggleDropdown}>
        {icon} {name}
      </Button>
      <DropdownWrapper
        $autoWidth={autoWidth}
        $isOpen={isOpen}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        {React.cloneElement(content, {
          closeDropdown: () => setIsOpen(false), // Pass the function to close the dropdown
        })}
      </DropdownWrapper>
    </Wrapper>
  );
};

export default Dropdown;
